import { render } from "./DashboardOffer.vue?vue&type=template&id=113e09fc&scoped=true"
import script from "./DashboardOffer.vue?vue&type=script&lang=ts"
export * from "./DashboardOffer.vue?vue&type=script&lang=ts"

import "./DashboardOffer.vue?vue&type=style&index=0&id=113e09fc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-113e09fc"

export default script